import { render } from "./iconNoWifi.vue?vue&type=template&id=61623d5d"
import script from "./iconNoWifi.vue?vue&type=script&lang=js"
export * from "./iconNoWifi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__